import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormElementsModule } from '../../form-elements';
import { CommonComponentsModule } from '../../common-components';
import { HttpClientModule } from '@angular/common/http';
import { MedicalUnderwritingRouteModule } from './medical-underwriting-route.module';
import { MedicalUnderwritingComponent} from './container/medical-underwriting.component';
import * as medicalComponents from './index';
import { SyncService } from './services/sync.service';
import { UtilityServiceForMedicalService } from './services/utility-service';
import { HoMedicalUnderwrittingComponent } from './container/HO/ho-medical-underwritting/ho-medical-underwritting.component';

@NgModule({
    declarations: [
        MedicalUnderwritingComponent,
        medicalComponents.AddMedicalConditionComponent,
        medicalComponents.DiabetesComponent,
        medicalComponents.DiabetesMedicalCondtionComponent,
        medicalComponents.DoctorDetailsComponent,
        medicalComponents.MedicalConditionComponent,
        medicalComponents.LifestyleNewComponent,
        medicalComponents.ControlTypesComponent,
        medicalComponents.EmptyComponent,
        medicalComponents.MandatoryQuestionsDirective,
        medicalComponents.DependentQuestionsDirective,
        medicalComponents.ValidateEventEmitterDirective,
        medicalComponents.AccordionValidateEventEmitterDirective,
        medicalComponents.ActivitiesOfDailyLivingComponent,
        HoMedicalUnderwrittingComponent,
        medicalComponents.HoSummaryUnderwritingComponent,
        medicalComponents.SafePipe
    ],
    imports: [
        CommonModule,
        FormElementsModule,
        FormsModule,
        ReactiveFormsModule,
        CommonComponentsModule,
        HttpClientModule,
        MedicalUnderwritingRouteModule
    ],
    providers: [
        SyncService,
        UtilityServiceForMedicalService
    ]
})
export class MedicalUnderwritingModule { }
